<div
    class="relative"
    [hidden]="hidden">
    @if (iframeLoading) {
        <div
            class="absolute top-0 left-0 h-full w-full z-10 bg-white/60 backdrop-blur-lg flex items-center justify-center">
            <span
                class="hd-spinner"
                role="status"
                aria-label="Loading"></span>
        </div>
    }
    @if (internalIframeLoading) {
        <div
            class="absolute left-1/2 top-4 -translate-x-1/2 z-[999999] p-2 bg-white rounded-lg shadow-lg">
            <span
                class="hd-spinner hd-spinner--sm"
                role="status"
                aria-label="Loading"></span>
        </div>
    }
    @if (iFrameSrc) {
        <iframe
            #myIframe
            class="h-[calc(100dvh-65px)]"
            frameBorder="0"
            [src]="iFrameSrc"
            (load)="iFrameLoaded(myIframe)"></iframe>
    }
</div>
